export const GET_DICTIONARY_ENTRIES_REQUEST = 'GET_DICTIONARY_ENTRIES_REQUEST';
export const GET_DICTIONARY_ENTRIES_SUCCESS = 'GET_DICTIONARY_ENTRIES_SUCCESS';
export const GET_DICTIONARY_ENTRIES_ERROR = 'GET_DICTIONARY_ENTRIES_ERROR';
export const SORT_DICTIONARY_ENTRIES = 'SORT_DICTIONARY_ENTRIES';
export const ADD_DICTIONARY_ENTRY_REQUEST = 'ADD_DICTIONARY_ENTRY_REQUEST';
export const ADD_DICTIONARY_ENTRY_SUCCESS = 'ADD_DICTIONARY_ENTRY_SUCCESS';
export const ADD_DICTIONARY_ENTRY_ERROR = 'ADD_DICTIONARY_ENTRY_ERROR';
export const UPDATE_DICTIONARY_ENTRY_REQUEST =
  'UPDATE_DICTIONARY_ENTRY_REQUEST';
export const UPDATE_DICTIONARY_ENTRY_SUCCESS =
  'UPDATE_DICTIONARY_ENTRY_SUCCESS';
export const UPDATE_DICTIONARY_ENTRY_ERROR = 'UPDATE_DICTIONARY_ENTRY_ERROR';
export const DELETE_DICTIONARY_ENTRY_REQUEST =
  'DELETE_DICTIONARY_ENTRY_REQUEST';
export const DELETE_DICTIONARY_ENTRY_SUCCESS =
  'DELETE_DICTIONARY_ENTRY_SUCCESS';
export const DELETE_DICTIONARY_ENTRY_ERROR = 'DELETE_DICTIONARY_ENTRY_ERROR';
export const DELETE_DICTIONARY_ENTRIES_REQUEST =
  'DELETE_DICTIONARY_ENTRIES_REQUEST';
export const DELETE_DICTIONARY_ENTRIES_SUCCESS =
  'DELETE_DICTIONARY_ENTRIES_SUCCESS';
export const DELETE_DICTIONARY_ENTRIES_ERROR =
  'DELETE_DICTIONARY_ENTRIES_ERROR';
export const UPDATE_DICTIONARY_ENTRIES_PAGINATION_PARAMS =
  'UPDATE_DICTIONARY_ENTRIES_PAGINATION_PARAMS';
export const UPDATE_SELECTED_ENTRIES = 'UPDATE_SELECTED_ENTRIES';
